(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-tuning-tape"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cg-tuning-tape')) return;

    const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
    const DRAW = 'cubic-bezier(0.32, 0.72, 0, 1)';

    class CGTuningTape extends HTMLElement {
      #anims = [];
      #timers = [];
      #io = null;
      #raf = 0;
      #revealed = false;
      #words = [];
      #hoverController = null;

      connectedCallback() {
        const readyFromFailsafe = this.hasAttribute('data-cg-tune-ready');
        this.#bindMobileHoverPhoto();
        // Theme editor re-renders the section on every setting change;
        // replaying the pre-hide + reveal would flash the band each edit.
        // Show statically (ready + taped) and skip all reveal work.
        if (window.Shopify?.designMode || document.documentElement.classList.contains('shopify-design-mode')) {
          this.setAttribute('data-cg-tune-ready', '');
          this.setAttribute('data-cg-tune-taped', '');
          this.#revealed = true;
          return;
        }
        if (readyFromFailsafe) {
          this.setAttribute('data-cg-tune-taped', '');
          this.#revealed = true;
          return;
        }
        if (!('animate' in Element.prototype)) {
          this.setAttribute('data-cg-tune-ready', '');
          this.setAttribute('data-cg-tune-taped', '');
          return;
        }

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const targets = [...this.querySelectorAll('[data-cg-tune-anim]')];
        targets.forEach((t) => {
          t.style.opacity = '0';
        });

        this.#words = [];
        if (!reduced) {
          const heading = this.querySelector('[data-cg-tune-heading]');
          if (heading) {
            if (heading.dataset.cgTuneSplit === 'true') {
              this.#words = [...heading.querySelectorAll('.cg-tune__word')];
            } else {
              this.#words = this.#splitHeading(heading);
              heading.dataset.cgTuneSplit = 'true';
            }
            heading.style.opacity = '1';
            this.#words.forEach((w) => {
              w.style.opacity = '0';
            });
          }
        }

        this.setAttribute('data-cg-tune-ready', '');
        this.#observe(() => {
          if (reduced) {
            this.#revealReduced(targets);
          } else {
            this.#reveal();
          }
        });
      }

      disconnectedCallback() {
        this.#io?.disconnect();
        this.#io = null;
        this.#anims.forEach((a) => a.cancel());
        this.#anims = [];
        this.#timers.forEach(clearTimeout);
        this.#timers = [];
        cancelAnimationFrame(this.#raf);
        this.#revealed = false;
        this.#hoverController?.abort();
        this.#hoverController = null;
        this.removeAttribute('data-cg-tune-ready');
        this.removeAttribute('data-cg-tune-taped');
      }

      #bindMobileHoverPhoto() {
        const media = this.querySelector('.cg-tune__media');
        if (!media || !media.querySelector('.cg-tune__img--hover')) return;

        const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.#hoverController?.abort();
        this.#hoverController = new AbortController();
        const signal = this.#hoverController.signal;
        const clear = () => media.removeAttribute('data-cg-tune-hover-active');

        media.addEventListener(
          'click',
          (event) => {
            if (hoverQuery.matches) return;
            // First tap swaps in the hover photo; a second tap on the
            // already-swapped media follows the wrapping product link
            // instead of re-toggling and trapping touch users here.
            if (media.hasAttribute('data-cg-tune-hover-active')) return;
            event.preventDefault();
            event.stopPropagation();
            media.toggleAttribute('data-cg-tune-hover-active');
          },
          { signal },
        );

        media.addEventListener('pointercancel', clear, { signal });
        // Detail: docs/comments/sections/cg-tuning-tape.md#a-touch-tap-fires-pointerleave-as-the-contact-lifts-before-the
        media.addEventListener(
          'pointerleave',
          (event) => {
            if (event.pointerType !== 'touch') clear();
          },
          { signal },
        );
        document.addEventListener(
          'click',
          (event) => {
            if (hoverQuery.matches) return;
            if (media.contains(event.target)) return;
            clear();
          },
          { signal },
        );
        hoverQuery.addEventListener('change', clear, { signal });
      }

      #observe(cb) {
        const fire = () => {
          if (this.#revealed) return;
          this.#revealed = true;
          cb();
        };
        const rect = this.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) {
          fire();
          return;
        }
        this.#io = new IntersectionObserver(
          (entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              this.#io?.disconnect();
              this.#io = null;
              fire();
            }
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.18 },
        );
        this.#io.observe(this);
      }

      /* Wrap each word of the heading in a span; element children (the <em>
         accent, <br>) become cascade units themselves. Whitespace text nodes
         are preserved so punctuation around the accent stays flush. */
      #splitHeading(heading) {
        const words = [];
        [...heading.childNodes].forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const frag = document.createDocumentFragment();
            node.textContent.split(/(\s+)/).forEach((token) => {
              if (!token) return;
              if (/^\s+$/.test(token)) {
                frag.append(token);
              } else {
                const span = document.createElement('span');
                span.className = 'cg-tune__word';
                span.textContent = token;
                frag.append(span);
                words.push(span);
              }
            });
            node.replaceWith(frag);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            node.classList.add('cg-tune__word');
            words.push(node);
          }
        });
        return words;
      }

      /* Inline-opacity-first + fill:'backwards' so the hidden start state holds
         through each stagger delay and the rest state survives interruption. */
      #play(el, frames, opts) {
        if (!el) return;
        el.style.opacity = '1';
        const anim = el.animate(frames, { easing: EASE, fill: 'backwards', ...opts });
        this.#anims.push(anim);
        this.#watch(anim, opts);
      }

      #watch(anim, opts = {}) {
        if (!anim) return;
        const timeout = (opts.delay || 0) + (opts.duration || 0) + 400;
        const timer = setTimeout(() => {
          if (anim.playState !== 'finished') anim.cancel();
        }, timeout);
        this.#timers.push(timer);
        if (anim.finished && typeof anim.finished.then === 'function') {
          anim.finished.then(
            () => clearTimeout(timer),
            () => clearTimeout(timer),
          );
        }
      }

      #reveal() {
        const el = (name) => this.querySelector(`[data-cg-tune-el="${name}"]`);
        const rise = (target, delay, dist = 16, dur = 600) => {
          this.#play(
            target,
            [
              { opacity: 0, transform: `translateY(${dist}px)` },
              { opacity: 1, transform: 'translateY(0)' },
            ],
            { duration: dur, delay },
          );
        };

        rise(el('eyebrow'), 0, 10, 500);

        this.#words.forEach((w, i) => {
          this.#play(
            w,
            [
              { opacity: 0, transform: 'translateY(-14px)' },
              { opacity: 1, transform: 'translateY(0)' },
            ],
            { duration: 600, delay: 120 + i * 55 },
          );
        });
        const wordsEnd = 120 + this.#words.length * 55;

        this.#timers.push(setTimeout(() => this.setAttribute('data-cg-tune-taped', ''), wordsEnd + 220));

        rise(el('subheading'), wordsEnd + 40, 12);
        rise(el('lede'), wordsEnd + 120, 14);

        const media = el('media');
        this.#play(
          media,
          [
            { opacity: 0, transform: 'translateY(22px) scale(0.985)' },
            { opacity: 1, transform: 'translateY(0) scale(1)' },
          ],
          { duration: 800, delay: 140 },
        );
        /* No image zoom inside the media frame: the 2s scale settle here was one
           of four different image scale-settles on the homepage, and only the
           hero keeps one (2026-09-20 homepage motion review, row 3). */
        const ruler = el('ruler');
        if (ruler) {
          ruler.style.opacity = '1';
          const ticks = el('ticks');
          if (ticks) {
            const opts = { duration: 900, delay: wordsEnd + 260, easing: DRAW, fill: 'backwards' };
            const anim = ticks.animate(
              [{ clipPath: 'inset(-40% 100% -40% -2%)' }, { clipPath: 'inset(-40% -2% -40% -2%)' }],
              opts,
            );
            this.#anims.push(anim);
            this.#watch(anim, opts);
          }
          const marker = el('marker');
          this.#play(
            marker,
            [
              { opacity: 0, transform: 'translateX(calc(-50% - 26px))' },
              { opacity: 1, transform: 'translateX(-50%)' },
            ],
            { duration: 700, delay: wordsEnd + 980 },
          );
          const count = el('count');
          if (count) {
            this.#timers.push(setTimeout(() => this.#countUp(count), wordsEnd + 1020));
          }
        }

        rise(el('actions'), wordsEnd + 320, 14);
        rise(el('spec'), wordsEnd + 420, 10, 500);
      }

      /* Tick the marker readout from 0 to its target, preserving the prefix,
         suffix, and decimal places of the merchant-entered value. */
      #countUp(el) {
        const text = el.textContent;
        const match = text.match(/-?\d+(?:\.\d+)?/);
        if (!match) return;
        const target = parseFloat(match[0]);
        const decimals = (match[0].split('.')[1] || '').length;
        const prefix = text.slice(0, match.index);
        const suffix = text.slice(match.index + match[0].length);
        const start = performance.now();
        const duration = 900;
        const tick = (now) => {
          const p = Math.min((now - start) / duration, 1);
          const eased = 1 - (1 - p) ** 3;
          el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
          if (p < 1) this.#raf = requestAnimationFrame(tick);
        };
        this.#raf = requestAnimationFrame(tick);
      }

      #revealReduced(targets) {
        this.setAttribute('data-cg-tune-taped', '');
        targets.forEach((t, i) => {
          t.style.opacity = '1';
          const opts = { duration: 240, delay: i * 35, easing: 'ease-out', fill: 'backwards' };
          const anim = t.animate([{ opacity: 0 }, { opacity: 1 }], opts);
          this.#anims.push(anim);
          this.#watch(anim, opts);
        });
      }
    }

    customElements.define('cg-tuning-tape', CGTuningTape);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-wholesale-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Second section instance on the same page: reuse the first controller so
    // the document shopify:section:load listener is never bound twice.
    if (window.CGWholesaleForm) {
      window.CGWholesaleForm.boot();
      return;
    }

    function isContactForm(form) {
      return !!form.querySelector('input[name="form_type"][value="contact"]');
    }

    function recalcLine(line) {
      if (!line) return;
      let total = 0;
      for (const input of line.querySelectorAll('[data-cg-wf-mult]')) {
        const count = Number.parseInt(input.value, 10);
        const mult = Number.parseInt(input.getAttribute('data-cg-wf-mult'), 10);
        if (!Number.isNaN(count) && count > 0 && !Number.isNaN(mult)) {
          total += count * mult;
        }
      }
      const out = line.querySelector('[data-cg-wf-total]');
      if (out) out.value = total > 0 ? String(total) : '';
    }

    function initWholesale(scope) {
      const roots = (scope || document).querySelectorAll('[data-cg-wholesale]');
      for (const root of roots) {
        const form = root.querySelector('form');
        if (!form || form.dataset.cgWfBound === 'true') continue;
        form.dataset.cgWfBound = 'true';
        form.addEventListener('input', (event) => {
          const target = event.target;
          if (target instanceof Element && target.matches('[data-cg-wf-mult]')) {
            recalcLine(target.closest('[data-cg-wf-line]'));
          }
        });
        for (const line of root.querySelectorAll('[data-cg-wf-line]')) {
          recalcLine(line);
        }
      }
    }

    // Detail: docs/comments/sections/cg-wholesale-form.md#two-contact-type-forms-can-share-the-contact-page-the-general-cg-page
    function scopeSuccess() {
      const hash = location.hash;
      if (!hash || hash.length < 2) return;
      for (const form of document.querySelectorAll('form[id]')) {
        if (!isContactForm(form)) continue;
        if ('#' + form.id === hash) continue;
        for (const note of form.querySelectorAll('[role="status"]')) {
          note.hidden = true;
        }
      }
    }

    function boot() {
      initWholesale(document);
      scopeSuccess();
    }

    if (document.readyState !== 'loading') {
      boot();
    } else {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    }

    document.addEventListener('shopify:section:load', (event) => {
      initWholesale(event.target);
      scopeSuccess();
    });

    window.CGWholesaleForm = { boot };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    const scrollToHashCard = () => {
      let id = url.hash.slice(1);
      try {
        id = decodeURIComponent(id);
      } catch {
        return;
      }
      const card = document.getElementById(id);
      if (card) {
        card.scrollIntoView({ behavior: 'auto' });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToHashCard, { once: true });
    } else {
      scrollToHashCard();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
